import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import cashInstructionApi from '@/features/dashboard/paymentConfig/api/cashInstructionApi.ts';
import { cashInstructionApiQueryKeys } from '@/features/dashboard/paymentConfig/api/cashInstructionApi.queryKeys.ts';
import { CashInstructionDto } from '@/features/dashboard/paymentConfig/types/CashInstructionDto.ts';

const useGetCashInstruction = () => {
  return useQuery(getCashInstructionQueryOptions());
};

export const getCashInstructionQueryOptions =
  (): UseQueryOptions<CashInstructionDto> => ({
    queryKey: cashInstructionApiQueryKeys.all(),
    queryFn: () => cashInstructionApi.get(),
    staleTime: 1000 * 60,
  });

export default useGetCashInstruction;
